import { render } from "./IPFinalStage.vue?vue&type=template&id=0b4e6b77"
import script from "./IPFinalStage.vue?vue&type=script&lang=js"
export * from "./IPFinalStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__